import { Button, Col, Form, Input, InputNumber, Row, Select, message } from 'antd';
import { useHistory } from 'react-router-dom';
import { Constants } from 'common/constants';
import { PATHS } from '@routing/routes';
import { useDispatch, useSelector } from 'react-redux';
import { InvoiceModel } from 'common/models';
import { SaveEmptyBoxInvoice, TransactionSelector } from '@features/Transaction';
import { PaymentTypeCodeList } from 'common/code/BookingCode';
import { OperationStatus } from 'store/rootTypes';
export const OrderBoxInvoice = () => {
  const history = useHistory();
  const transactionState = useSelector(TransactionSelector);
  const dispatch = useDispatch();

  const handleMouseLeave = (field, value) => {
    if (field === 'UnitCount' || field === 'BasicCharge' || field === 'AmountPaid') {
      const unitCountValue = parseFloat(form.getFieldValue('UnitCount')) || 0;
      const basicChargeValue = parseFloat(form.getFieldValue('BasicCharge')) || 0;
      const amountPaidValue = parseFloat(form.getFieldValue('AmountPaid')) || 0;
      let totalAmount = 0;
      // Calculate TotalAmount based on the provided formula

      totalAmount = unitCountValue * basicChargeValue;
      // Calculate Balance based on the provided formula
      const balance = Math.max(totalAmount - amountPaidValue, 0);

      // Calculate Change based on the provided formula
      const change = Math.max(amountPaidValue - totalAmount, 0);

      form.setFieldsValue({
        TotalAmount: totalAmount.toFixed(2),
        Balance: balance.toFixed(2),
        Change: change.toFixed(2),
      });
    }
  };

  const [form] = Form.useForm();

  const onFinish = async (values: InvoiceModel) => {
    // Access all form values from the 'values' parameter
    const {
      Type,
      Destination,
      UnitCount,
      Weight,
      BasicCharge,
      ServiceCharge,
      KmCharge,
      OtherCharges,
      InsuranceCharge,
      Deposit,
      AmountPaid,
      Discount,
      TotalAmount,
      Balance,
      Change,
      PaymentMode,
      Notes,
      Bonus,
    } = values;

    // Prepare the data to be sent to your API
    const requestData: InvoiceModel = {
      Type,
      Destination,
      UnitCount: UnitCount.toString(),
      Weight,
      BasicCharge: BasicCharge ?? 0,
      ServiceCharge: ServiceCharge ?? 0,
      KmCharge: KmCharge ?? 0,
      OtherCharges: OtherCharges ?? 0,
      InsuranceCharge: InsuranceCharge ?? 0,
      Deposit: Deposit ?? 0,
      AmountPaid: AmountPaid ?? 0,
      Discount: Discount ?? 0,
      TotalAmount,
      Balance,
      Change,
      PaymentMode,
      Notes,
      Id: transactionState.TransactionSummary?.Invoice?.Id,
      TransactionsId: transactionState.TransactionSummary?.Transactions.Id,
      Bonus,
    };
    await dispatch(SaveEmptyBoxInvoice(requestData));

    message.success('Invoice updated successfully');
    history.push('/transaction/summaryorderbox');
  };
  return (
    <div className="App">
      <Row justify="center" align="middle">
        <h1>Acknowledgement receipt</h1>
      </Row>

      <Form name="senderForm" layout="vertical" onFinish={onFinish} form={form}>
        <Row justify="center" align="middle">
          <Col xs={24} sm={20} md={12} lg={8} xl={6}>
            <Form.Item
              label="Unit count"
              name="UnitCount"
              rules={[{ required: true, message: Constants.REQUIRED_FIELD }]}
              initialValue={
                transactionState?.Invoice?.UnitCount ?? transactionState.TransactionSummary?.BoxOrder.Quantity
              }
            >
              <Input
                size="large"
                maxLength={150}
                onBlur={() => handleMouseLeave('UnitCount', form.getFieldValue('UnitCount'))}
              />
            </Form.Item>
            <Form.Item
              label="Basic charge"
              name="BasicCharge"
              // rules={[{ required: true, message: Constants.REQUIRED_FIELD }]}
              rules={[
                {
                  validator: (_, value) => {
                    if (value == null || value === '') {
                      return Promise.reject(new Error(Constants.REQUIRED_FIELD));
                    }
                    if (value <= 0) {
                      return Promise.reject(new Error(Constants.REQUIRED_FIELD));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
              initialValue={transactionState?.Invoice?.BasicCharge}
            >
              <InputNumber<string>
                min="0"
                max="1000000"
                step={0.01}
                stringMode
                size="large"
                precision={2}
                className="full-width"
                placeholder="0.00"
                onBlur={() => handleMouseLeave('BasicCharge', form.getFieldValue('BasicCharge'))}
              />
            </Form.Item>
            <Form.Item
              initialValue={transactionState?.Invoice?.TotalAmount}
              label="Total amount"
              name="TotalAmount"
              // rules={[{ required: true, message: Constants.REQUIRED_FIELD }]}
            >
              <InputNumber<string>
                min="0"
                max="1000000"
                step={0.01}
                stringMode
                size="large"
                precision={2}
                className="full-width"
                placeholder="0.00"
                disabled
              />
            </Form.Item>
            <Form.Item
              initialValue={transactionState?.Invoice?.AmountPaid}
              label="Amount paid"
              name="AmountPaid"
              // rules={[{ required: true, message: Constants.REQUIRED_FIELD }]}
            >
              <InputNumber<string>
                min="0"
                max="1000000"
                step={0.01}
                stringMode
                size="large"
                precision={2}
                className="full-width"
                placeholder="0.00"
                onBlur={() => handleMouseLeave('AmountPaid', form.getFieldValue('AmountPaid'))}
              />
            </Form.Item>

            <Form.Item label="Amount due" initialValue={transactionState?.Invoice?.Balance} name="Balance">
              <InputNumber<string>
                min="0"
                max="1000000"
                step={0.01}
                stringMode
                size="large"
                precision={2}
                className="full-width"
                placeholder="0.00"
                disabled
              />
            </Form.Item>
            <Form.Item label="Change" name="Change" initialValue={transactionState?.Invoice?.Change}>
              <InputNumber<string>
                min="0"
                max="1000000"
                step={0.01}
                stringMode
                size="large"
                precision={2}
                className="full-width"
                placeholder="0.00"
                disabled
              />
            </Form.Item>
            <Form.Item
              initialValue={transactionState?.Invoice?.PaymentMode}
              label="Mode of payment"
              name="PaymentMode"
              rules={[{ required: true, message: Constants.REQUIRED_FIELD }]}
            >
              <Select size="large" showSearch placeholder="Select" optionFilterProp="children">
                {PaymentTypeCodeList.map((destination) => (
                  <Select.Option key={destination.code} value={destination.code}>
                    {destination.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <div>
              <Button
                className="prevSenderBtn"
                size="large"
                type="default"
                onClick={() => history.push(PATHS.SummaryOrderBox.path)}
              >
                {Constants.BTN_BACK}
              </Button>
              <Button
                className="nextSenderBtn"
                size="large"
                type="primary"
                htmlType="submit"
                loading={transactionState.submitStatus == OperationStatus.pending}
              >
                {transactionState.TransactionSummary?.Transactions.Id ? Constants.BTN_UPDATE : Constants.BTN_SUBMIT}
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
